

const SkeltonTableRow = () => {
    return (
        <>
            {
                Array.from(Array(10)).map((item, index) => {
                    return (
                        <tr
                            className="relative font-medium animate-pulse border-t border-t-1 border-t-edge-faint"
                            key={index}
                        >
                            <td className="w-[12%] py-3">
                                <div className="h-6 bg-overlay-mid border border-edge-faint rounded-sm w-[90%]"></div>
                                <div className="h-4 bg-overlay-mid border border-edge-faint rounded-sm w-[90%] mt-[4px]"></div>
                            </td>
                            <td className="text-light-gray py-3 w-[24%]">
                                <div className="h-6 bg-overlay-mid border border-edge-faint rounded-sm w-[90%]"></div>
                                <div className="h-4 bg-overlay-mid border border-edge-faint rounded-sm w-[90%] mt-[4px]"></div>
                            </td>
                            <td className="py-3 text-light-gray w-[12%]">
                                <div className="h-6 bg-overlay-mid border border-edge-faint rounded-sm w-[90%]"></div>
                                <div className="h-4 bg-overlay-mid border border-edge-faint rounded-sm w-[90%] mt-[4px]"></div>
                            </td>
                            <td className="py-3 text-light-gray w-[10%]">
                                <div className="h-6 bg-overlay-mid border border-edge-faint rounded-sm w-[90%]"></div>
                                <div className="h-4 bg-overlay-mid border border-edge-faint rounded-sm w-[90%] mt-[4px]"></div>
                            </td>
                            <td className="py-3 text-light-gray w-[10%]">
                                <div className="h-6 bg-overlay-mid border border-edge-faint rounded-sm w-[90%]"></div>
                                <div className="h-4 bg-overlay-mid border border-edge-faint rounded-sm w-[90%] mt-[4px]"></div>
                            </td>
                            <td className="py-3 text-light-gray w-[10%]">
                                <div className="h-6 bg-overlay-mid border border-edge-faint rounded-sm w-[90%]"></div>
                                <div className="h-4 bg-overlay-mid border border-edge-faint rounded-sm w-[90%] mt-[4px]"></div>
                            </td>
                            <td className="py-3 mr-1 text-light-gray w-[12%]">
                                <div className="h-6 bg-overlay-mid border border-edge-faint rounded-sm w-[90%]"></div>
                                <div className="h-4 bg-overlay-mid border border-edge-faint rounded-sm w-[90%] mt-[4px]"></div>
                            </td>
                            <td className="px-2 cursor-pointer">
                                <div className="h-6 bg-overlay-mid border border-edge-faint rounded-sm w-[90%]"></div>
                                <div className="h-4 bg-overlay-mid border border-edge-faint rounded-sm w-[90%] mt-[4px]"></div>
                            </td>
                            <td className="px-2 relative">
                                <div className="h-6 bg-overlay-mid border border-edge-faint rounded-sm w-[90%]"></div>
                                <div className="h-4 bg-overlay-mid border border-edge-faint rounded-sm w-[90%] mt-[4px]"></div>

                            </td>
                            <td>

                            </td>
                        </tr>
                    )
                })
            }
        </>
    )
}

export default SkeltonTableRow
